<template>
	<div>
		<p class="" style="padding: .2rem;padding-bottom: 0;;font-size: .22rem;color:var(--theme-text-color) ;">
			{{$t('_home._Podeserresgatadohoje')}}
			<span style="margin-left: .2rem;color: var(--theme-secondary-color-finance);">{{betRebateDatList.all_bonus}}</span>
		</p>
		
		<div class="C7A8L1rNeyjp6YiJbCkw ">
			<!-- --theme-text-color -->
			<div class="SkyXvrctNhPDnWZtC66x">
				<div class="common-tabs-box1">
					<ul class="common-tabs-nav P8RuaFULZKF3ME9gfgKl uxYYjiDd7u0QtHMh5yW3" style="width: 1.5rem;">
						<li
							class="TAg1HOhNrjpbcFzq75mo  bNrPaNsp97Sa9hmzMKZl subItem JOWqBceNWiyZuqdBAXLg sZKC80YroX_W1LCaI5C_ isVertical event-tab-item tab-1 ">
							<svg-icon className="imageWrap" icon-class="icon_dtfl_dz_0--svgSprite:all" />
							<div class="vi_TBZvr4AMy0V63Nni7 OYGFKea9dvDSZrAB5rQS text"><span>{{$t('_home._Slots')}}</span></div>
						</li>
						<li class="TAg1HOhNrjpbcFzq75mo menComesnts"
						 @click="ReceberTudo()"
						 :class="{
							active:betRebateDatList.open_tips,
							mensgte:!betRebateDatList.open_tips,
						}" v-if="!is_vuex_token">
							<div class="vi_TBZvr4AMy0V63Nni7 OYGFKea9dvDSZrAB5rQS text"><span> {{$t('_home._ReceberTudo')}} </span></div>
						</li>
						<li @click="openUrl('records')" class="TAg1HOhNrjpbcFzq75mo  menComesnts ">
							<div class="vi_TBZvr4AMy0V63Nni7 OYGFKea9dvDSZrAB5rQS text"><span>{{$t('promote._Histórico')}}</span></div>
						</li>
					</ul>
				</div>
			</div>
			
			<div>
				<div class="eteMneLIst" v-for="(item,index) in betRebateDatList.list.slot">
					<div class="_center_3yhn0_52" @click="openUrl('TaxadeRebateDetails')">
						<div>
							<div class="_centerLeft_3yhn0_69">
								<img class="lobby-image lobby-image _icon_3yhn0_74"
									:src="item.icon" alt=".">
								<div class="_item_3yhn0_79">
									<label>{{$t('promote._ApostasVálidas')}}</label>
									<span class="_lead_3yhn0_83">{{item.valid_bet}}</span>
								</div>
							</div>
							<div class="_centerRight_3yhn0_86">
								<div class="_item_3yhn0_79">
									<label>{{$t('popup._TaxadeRebate')}}</label><span class="_lead_3yhn0_83">{{item.rate}}</span>
								</div>
							</div>
						</div>
						<div>
							<div class="_progressWrapper_3yhn0_30">
								<div class="ui-progress">
									<span class="ui-progress__portion" style="width: 0%;"></span>
									<span
										class="ui-progress__text"
										style="left: 50%; transform: translate(-50%, 0px); text-overflow: ellipsis; width: 100%; overflow: hidden;">Aposte
										{{item.need_bet}} {{$t('popup._parareceber')}} {{item.next_rate}}</span>
								</div>
							</div>
							<p class="_centerRight_3yhn0_86">
								<label>{{$t('promote._Coletável')}}</label>
								<span class="_receiveAmt_3yhn0_33">{{item.bonus}}</span>
							</p>
						</div>
					</div>
					<svg-icon className="EzRod1ZnSBOWKZYQpbwb" icon-class="comm_icon_fh--svgSprite:all" />

				</div>

				
			
			</div>
		</div>

	</div>
</template>

<script>
	import {
		betRebate
	} from "@/apis/modules/detail.js"
	// 
	import {
		claimActivityRewards
	} from "@/apis/modules/detail.js"
	import { Toast } from 'vant';
	export default {
		props: {
			name: String,
			item: {
				type: [Array, Object],
				required: [],
			},
			formDelList: {
				type: [Array, Object],
				default: () => {
					return {
					}
				},
			}
		},
		data() {
			return {
				showPopover: false,
				betRebateDatList:{},
				is_vuex_token:typeof this._vuex_token() != 'string',
			};
		},
		created() {
			
			this.betRebate();
		},
		methods: {
			ReceberTudo(){
				if(!this.betRebateDatList.open_tips){
					return false;
				}
				claimActivityRewards({
					activity:'betRebate'
				}).then(({
					code,
					data,
					msg
				}) => { //404
					if(code==0){
						Toast.success(msg);
						this.betRebate();
						open_tips
					}else{
						Toast.loading(msg);
					}
				})
			},
			betRebate() {
				betRebate({}).then(({
					code,
					data,
					msg
				}) => {
					this.betRebateDatList=data;
				})
			},
			onChange(e) {
				console.log(e)
			}
		}
	};
</script>
<style>
	.foosuTs {
		color: var(--theme-text-color-lighten);
		font-size: .2rem;
		padding: .1rem;
		background: var(--theme-main-bg-color);
		border: thin solid var(--theme-color-line);
		border-radius: .1rem;
		max-width: 3.6rem;
		line-height: 1.5;
	}

	.foosuTs.van-hairline--top::after {
		display: none;
	}

	.foosuTs .ant-popover-inner-content {
		line-height: 1.5;
	}

	.van-popover__content {
		border-radius: .1rem;
	}

	.van-popover--dark .van-popover__arrow {
		background: transparent;
		border-style: solid;
		border-width: 4.24264069px;
		display: block;
		height: 8.48528137px;
		transform: initial;
		position: absolute;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		width: 8.48528137px;
		border-bottom-width: initial;
		bottom: -4px !important;
		border-style: solid;
		z-index: 99;
		width: 8px;
		border-width: 4px;
		box-shadow: 3px 3px 7px rgba(0, 0, 0, .07);
		background-color: var(--theme-main-bg-color);
		border-color: var(--theme-color-line) !important;
		border-style: solid;
		border-width: 0 .01rem .01rem 0;
	}
</style>
<style scoped>
	.EzRod1ZnSBOWKZYQpbwb{
		/* opacity: .27; */
		    fons-size: .14rem;
		    width: .24rem;
		    height: .24rem;
		    transform: rotate(180deg);
			color: var(--theme-text-color-darken) !important;
	}
	._center_3yhn0_52 {
	    padding-left: .1rem
	}
	._center_3yhn0_52>div {
	    display: flex;
	    align-items: center;
	    justify-content: space-between
	}
	.ui-progress {
	    position: relative;
		width: 100%;
	    height: .2rem;
	    background: var(--theme-text-color-placeholder);
	    border-radius: .2rem;
	    overflow: hidden
	}
	.ui-progress__portion{
		background-color: var(--theme-secondary-color-success);
		display: block;
		height: 100%;
	}
	._lead_3yhn0_83{
		color: var(--theme-text-color-darken);
	}
	._receiveAmt_3yhn0_33{
		color: var(--theme-secondary-color-finance);
	}
	.ui-progress__text {
	    position: absolute;
	    top: 0;
	    box-sizing: border-box;
	    color: #fff;
	    height: .2rem;
	    line-height: .2rem;
	    font-size: .2rem;
	    text-align: center;
	    word-break: keep-all;
	    white-space: nowrap
	}

	._progressWrapper_3yhn0_30,._center_3yhn0_52 ._centerLeft_3yhn0_69 {
	    width: 2.6rem;
	    display: flex;
	    align-items: center
	}
	 ._center_3yhn0_52 ._centerLeft_3yhn0_69 ._icon_3yhn0_74 {
	    margin-right: .1rem;
	    width: .5rem;
	    height: .5rem
	}
	._center_3yhn0_52 ._centerLeft_3yhn0_69 ._item_3yhn0_79 {
	    display: flex;
	    align-items: baseline;
	}

	 ._center_3yhn0_52 ._centerRight_3yhn0_86 {
	    display: flex;
	    align-items: center;
		    width: 2.01rem;
		    padding-right: .04rem;
			padding-left: .2rem;
	}
	 ._center_3yhn0_52 ._centerRight_3yhn0_86 ._item_3yhn0_79{
		 align-items: center;
		 display: flex;
	 }
	
	.eteMneLIst {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 1.06rem;
		margin-bottom: .2rem;
		padding: .2rem 0 .2rem .1rem;
		font-size: .2rem;
		background-color: var(--theme-main-bg-color);
		border-radius: .12rem;
		box-sizing: border-box;
		box-shadow: 0 .05rem .18rem rgba(0, 0, 0, .06);
		cursor: pointer;
		color: var(--theme-text-color-lighten);
	}

	.OYGFKea9dvDSZrAB5rQS {
		text-align: center;
		font-size: .17rem;
	}

	.C7A8L1rNeyjp6YiJbCkw .van-popover__arrow {
		background-color: var(--theme-main-bg-color);
		border-color: var(--theme-color-line) !important;
		border-style: solid;
		border-width: 0 .01rem .01rem 0
	}

	.TAg1HOhNrjpbcFzq75mo {
		background: var(--theme-primary-color);
		border: initial;
		color: var(--theme-primary-font-color);
		border-radius: .2rem;
		display: flex;
		justify-content: center;
		padding: 0 .1rem;
		border-radius: .16rem;
		align-items: center;
		margin-bottom: .2rem;
		height: .7rem;
		flex-direction:row;
	}

	.menComesnts {
		height: .5rem;
		width: 1.2rem;
		padding: .2rem .05rem;
		box-sizing: border-box;
		font-size: .2rem;
		margin-left: .2rem;
	}

	.menComesnts.mensgte {
		background-color: var(--theme-disabled-bg-color);
		border-color: var(--theme-disabled-bg-color);
		color: var(--theme-disabled-font-color);
	}
	.menComesnts.active {
		background-color: var(--theme-secondary-color-success);
		border-color: var(--theme-secondary-color-success);
		color: var(--theme-disabled-font-color);
	}
	.TAg1HOhNrjpbcFzq75mo .imageWrap {
		width: .52rem;
		height: .82rem;
		margin-right: .2rem;
	}

	.SkyXvrctNhPDnWZtC66x {
		height: calc(var(--vh, 1vh)*100 - 2rem) !important;
		margin-right: .2rem;
		padding-right: .3rem;
		box-sizing: border-box;
		max-height: calc(var(--vh, 1vh)*100 - 2rem) !important;
		overflow: scroll
	}

	.C7A8L1rNeyjp6YiJbCkw {
		background: none;
		-webkit-box-shadow: none;
		display: flex;
		justify-content: space-between;
		box-shadow: none;
		padding: .2rem .2rem 0
	}

	.header {
		height: .8rem;
		background: var(--theme-main-bg-color);
		font-size: .24rem;
	}

	.tenConter .tr._disps {
		display: flex;
		flex-wrap: wrap;
	}

	.tenConter-table-body .tenConter {
		font-size: .2rem;
		height: .7rem;
	}

	.tenConter-table-body .tenConter .JlCRc6ttKGcNUyDwFygw {
		color: var(--theme-text-color-lighten);
	}

	.tenConter-table-body .tenConter .RL9TJMMzDMOQihFhVnG2 {
		color: var(--theme-secondary-color-finance) !important;
	}

	.JlCRc6ttKGcNUyDwFygw img,
	.NPzDoGC69c0JdVxoaQso img,
	.l2ogUtOtFSdH0ER0ochY img {
		position: absolute
	}

	.JlCRc6ttKGcNUyDwFygw span:before,
	.NPzDoGC69c0JdVxoaQso span:before,
	.l2ogUtOtFSdH0ER0ochY span:before {
		-webkit-background-clip: text;
		background-clip: text;
		background-image: -webkit-gradient(linear, left top, left bottom, from(#f7ea94), color-stop(51%, #e5b952), to(#ce9510));
		background-image: linear-gradient(180deg, #f7ea94 0, #e5b952 51%, #ce9510);
		background-size: cover;
		content: attr(data-text);
		height: 100%;
		left: 0;
		position: absolute;
		text-shadow: none;
		top: 0;
		width: 100%;
		z-index: 0
	}

	.l2ogUtOtFSdH0ER0ochY {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		background-position: 50%;
		background-repeat: no-repeat;
		background-size: contain;
		display: flex;
		justify-content: center;
		margin: auto;
		position: relative;
		text-align: center;
	}

	.JlCRc6ttKGcNUyDwFygw span,
	.NPzDoGC69c0JdVxoaQso span,
	.l2ogUtOtFSdH0ER0ochY span {
		color: transparent;
		display: inline-block;
		font-style: normal;
		font-weight: 700;
		position: relative;
		text-shadow: 0 .01rem 0 rgba(0, 0, 0, .4)
	}

	._2lvGimPeAnoEFiUw_fTw {
		position: relative;
		width: 3.1rem;
		margin-top: .1rem;
	}

	._2lvGimPeAnoEFiUw_fTw .ant-progress-inner {
		background-color: var(--theme-text-color-placeholder);
		border-radius: .2rem
	}

	._2lvGimPeAnoEFiUw_fTw .ant-progress-inner .ant-progress-bg {
		background-color: var(--theme-vip-progress-bg-color);
		border-radius: .2rem !important;
		height: .2rem !important;
	}

	._2lvGimPeAnoEFiUw_fTw>span {
		-webkit-background-clip: text !important;
		color: #fff;
		font-size: .16rem;
		left: 50%;
		overflow: hidden;
		position: absolute;
		text-align: center;
		text-overflow: ellipsis;
		top: 60%;
		transform: translate(-50%, -58%);
		white-space: nowrap;
		width: 94%
	}
</style>